var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleStoreButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 47,
    viewBox: "0 0 160 47",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.074 46.4444H5.92593C2.66815 46.4444 0 43.843 0 40.6667V5.99999C0 2.82365 2.66815 0.222208 5.92593 0.222208H154.074C157.332 0.222208 160 2.82365 160 5.99999V40.6667C160 43.843 157.332 46.4444 154.074 46.4444Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.074 1.1481C156.818 1.1481 159.05 3.32487 159.05 5.99999V40.6667C159.05 43.3418 156.818 45.5185 154.074 45.5185H5.92593C3.18222 45.5185 0.949629 43.3418 0.949629 40.6667V5.99999C0.949629 3.32487 3.18222 1.1481 5.92593 1.1481H154.074ZM154.074 0.222208H5.92593C2.66815 0.222208 0 2.82365 0 5.99999V40.6667C0 43.843 2.66815 46.4444 5.92593 46.4444H154.074C157.332 46.4444 160 43.843 160 40.6667V5.99999C160 2.82365 157.332 0.222208 154.074 0.222208Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3675 8.93364C12.0194 9.28898 11.8179 9.8422 11.8179 10.5586V36.1138C11.8179 36.8302 12.0194 37.3834 12.3675 37.7388L12.4534 37.8168L27.1408 23.5023V23.1643L12.4534 8.84987L12.3675 8.93364Z",
    fill: "url(#paint0_linear_1740_17426)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.031 28.2762L27.1406 23.5023V23.1643L32.0369 18.3904L32.1466 18.4525L37.9451 21.6693C39.5999 22.5822 39.5999 24.0844 37.9451 25.0031L32.1466 28.2141L32.031 28.2762Z",
    fill: "url(#paint1_linear_1740_17426)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1469 28.2141L27.141 23.3333L12.3677 37.7388C12.9173 38.3021 13.8136 38.37 14.8329 37.8066L32.1469 28.2141Z",
    fill: "url(#paint2_linear_1740_17426)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1469 18.4525L14.8329 8.85998C13.8136 8.30243 12.9173 8.37031 12.3677 8.93365L27.141 23.3333L32.1469 18.4525Z",
    fill: "url(#paint3_linear_1740_17426)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1984 12.0594C56.1984 13.0243 55.9021 13.7971 55.3184 14.3734C54.6473 15.0566 53.7732 15.4004 52.7021 15.4004C51.6784 15.4004 50.8043 15.0509 50.0873 14.3619C49.3688 13.6628 49.0103 12.8048 49.0103 11.7778C49.0103 10.7508 49.3688 9.89276 50.0873 9.19942C50.8043 8.50465 51.6784 8.15509 52.7021 8.15509C53.2117 8.15509 53.6977 8.25765 54.1614 8.44831C54.6236 8.64042 54.9999 8.90042 55.2725 9.22109L54.6532 9.83065C54.1777 9.2832 53.5303 9.01309 52.7021 9.01309C51.9554 9.01309 51.308 9.26731 50.7584 9.78009C50.2147 10.2943 49.9421 10.9602 49.9421 11.7778C49.9421 12.5953 50.2147 13.267 50.7584 13.7812C51.308 14.2882 51.9554 14.5482 52.7021 14.5482C53.4947 14.5482 54.1614 14.2882 54.6873 13.7754C55.034 13.436 55.231 12.968 55.2828 12.37H52.7021V11.5351H56.1451C56.1865 11.7156 56.1984 11.8904 56.1984 12.0594Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.0948148,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6604 9.16476H58.4263V11.3603H61.3419V12.1952H58.4263V14.3908H61.6604V15.2415H57.5107V8.31398H61.6604V9.16476Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.0948148,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5155 15.2415H64.5999V9.16476H62.6162V8.31398H67.5007V9.16476H65.5155V15.2415Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.0948148,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0356 15.2415V8.31398H71.9497V15.2415H71.0356Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.0948148,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0013 15.2415H75.0932V9.16476H73.1021V8.31398H77.9924V9.16476H76.0013V15.2415Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.0948148,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2398 14.3503C86.539 15.0509 85.6709 15.4004 84.6353 15.4004C83.5938 15.4004 82.7257 15.0509 82.0249 14.3503C81.3257 13.6512 80.9775 12.7932 80.9775 11.7778C80.9775 10.7623 81.3257 9.90431 82.0249 9.2052C82.7257 8.50465 83.5938 8.15509 84.6353 8.15509C85.6649 8.15509 86.5331 8.50465 87.2338 9.21098C87.939 9.91587 88.2872 10.7681 88.2872 11.7778C88.2872 12.7932 87.939 13.6512 87.2398 14.3503ZM82.702 13.7696C83.2294 14.2882 83.8709 14.5482 84.6353 14.5482C85.3938 14.5482 86.0412 14.2882 86.5627 13.7696C87.0887 13.2511 87.3553 12.5852 87.3553 11.7778C87.3553 10.9703 87.0887 10.3044 86.5627 9.78587C86.0412 9.26731 85.3938 9.00731 84.6353 9.00731C83.8709 9.00731 83.2294 9.26731 82.702 9.78587C82.1761 10.3044 81.9094 10.9703 81.9094 11.7778C81.9094 12.5852 82.1761 13.2511 82.702 13.7696Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.0948148,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5718 15.2415V8.31398H90.6829L94.1377 13.7018H94.1777L94.1377 12.37V8.31398H95.0518V15.2415H94.0977L90.4799 9.58798H90.4399L90.4799 10.9255V15.2415H89.5718Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.0948148,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7527 25.3584C77.969 25.3584 75.6949 27.424 75.6949 30.2739C75.6949 33.1007 77.969 35.1879 80.7527 35.1879C83.5423 35.1879 85.8164 33.1007 85.8164 30.2739C85.8164 27.424 83.5423 25.3584 80.7527 25.3584ZM80.7527 33.2523C79.2253 33.2523 77.9112 32.0231 77.9112 30.2739C77.9112 28.5016 79.2253 27.294 80.7527 27.294C82.2801 27.294 83.6001 28.5016 83.6001 30.2739C83.6001 32.0231 82.2801 33.2523 80.7527 33.2523ZM69.7172 25.3584C66.9275 25.3584 64.6594 27.424 64.6594 30.2739C64.6594 33.1007 66.9275 35.1879 69.7172 35.1879C72.5053 35.1879 74.7749 33.1007 74.7749 30.2739C74.7749 27.424 72.5053 25.3584 69.7172 25.3584ZM69.7172 33.2523C68.1883 33.2523 66.8698 32.0231 66.8698 30.2739C66.8698 28.5016 68.1883 27.294 69.7172 27.294C71.2446 27.294 72.5586 28.5016 72.5586 30.2739C72.5586 32.0231 71.2446 33.2523 69.7172 33.2523ZM56.5853 26.865V28.9537H61.7009C61.5512 30.1208 61.1512 30.9788 60.5379 31.5768C59.7912 32.299 58.6283 33.1007 56.5853 33.1007C53.4372 33.1007 50.972 30.6234 50.972 27.554C50.972 24.4846 53.4372 22.0073 56.5853 22.0073C58.2875 22.0073 59.5261 22.6559 60.4401 23.4966L61.9498 22.0247C60.6712 20.8344 58.9705 19.9201 56.5853 19.9201C52.2683 19.9201 48.6401 23.3449 48.6401 27.554C48.6401 31.7631 52.2683 35.1879 56.5853 35.1879C58.9187 35.1879 60.6712 34.4426 62.049 33.0443C63.4609 31.6678 63.9009 29.7322 63.9009 28.1693C63.9009 27.684 63.8594 27.2377 63.7853 26.865H56.5853ZM110.283 28.4842C109.867 27.385 108.582 25.3584 105.966 25.3584C103.373 25.3584 101.215 27.3503 101.215 30.2739C101.215 33.027 103.351 35.1879 106.215 35.1879C108.53 35.1879 109.867 33.8113 110.416 33.0097L108.698 31.8931C108.125 32.7107 107.344 33.2523 106.215 33.2523C105.093 33.2523 104.289 32.7511 103.773 31.7631L110.516 29.0432L110.283 28.4842ZM103.409 30.1208C103.351 28.2257 104.919 27.255 106.042 27.255C106.922 27.255 107.668 27.684 107.917 28.2979L103.409 30.1208ZM97.929 34.8889H100.145V20.4444H97.929V34.8889ZM94.2994 26.4533H94.2253C93.7275 25.8784 92.7779 25.3584 91.5749 25.3584C89.0505 25.3584 86.7424 27.5193 86.7424 30.2898C86.7424 33.0443 89.0505 35.1879 91.5749 35.1879C92.7779 35.1879 93.7275 34.6636 94.2253 34.0713H94.2994V34.7762C94.2994 36.6554 93.2697 37.6651 91.609 37.6651C90.2549 37.6651 89.4149 36.7118 89.0683 35.9101L87.1409 36.6944C87.6964 37.9973 89.1675 39.6007 91.609 39.6007C94.2075 39.6007 96.4001 38.11 96.4001 34.483V25.6574H94.2994V26.4533ZM91.7646 33.2523C90.2372 33.2523 88.9586 32.0058 88.9586 30.2898C88.9586 28.5579 90.2372 27.294 91.7646 27.294C93.2698 27.294 94.4564 28.5579 94.4564 30.2898C94.4564 32.0058 93.2698 33.2523 91.7646 33.2523ZM120.659 20.4444H115.359V34.8889H117.569V29.4159H120.659C123.114 29.4159 125.522 27.684 125.522 24.9294C125.522 22.1763 123.108 20.4444 120.659 20.4444ZM120.717 27.4067H117.569V22.4537H120.717C122.368 22.4537 123.31 23.7898 123.31 24.9294C123.31 26.0474 122.368 27.4067 120.717 27.4067ZM134.381 25.331C132.784 25.331 131.123 26.0186 130.44 27.5424L132.402 28.3441C132.824 27.5424 133.6 27.2824 134.421 27.2824C135.568 27.2824 136.73 27.9541 136.748 29.14V29.2917C136.348 29.0663 135.492 28.7327 134.439 28.7327C132.326 28.7327 130.173 29.8666 130.173 31.9827C130.173 33.9182 131.904 35.1648 133.849 35.1648C135.336 35.1648 136.157 34.5104 136.673 33.7492H136.748V34.8658H138.883V29.3249C138.883 26.7639 136.922 25.331 134.381 25.331ZM134.114 33.2466C133.391 33.2466 132.384 32.897 132.384 32.0231C132.384 30.9051 133.64 30.4761 134.728 30.4761C135.701 30.4761 136.157 30.6856 136.748 30.9614C136.575 32.299 135.394 33.2466 134.114 33.2466ZM146.661 25.6473L144.12 31.909H144.045L141.418 25.6473H139.034L142.981 34.3978L140.729 39.267H143.039L149.12 25.6473H146.661ZM126.736 34.8889H128.953V20.4444H126.736V34.8889Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1740_17426",
    x1: 25.8368,
    y1: 36.3799,
    x2: 6.44998,
    y2: 16.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1740_17426",
    x1: 40.0999,
    y1: 23.3317,
    x2: 11.4221,
    y2: 23.3317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1740_17426",
    x1: 29.4249,
    y1: 20.68,
    x2: 3.13481,
    y2: -6.28411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1740_17426",
    x1: 8.64892,
    y1: 46.2408,
    x2: 20.3886,
    y2: 34.2002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleStoreButton);
export default __webpack_public_path__ + "static/media/googleStoreButton.7e6dfcd0ed37b573e4b22280e28f93fd.svg";
export { ForwardRef as ReactComponent };